import ShiftEventEdit from '@/components/ezuro/constants/shifts/events/edit/ShiftEventEdit.vue'

export default {
  name: 'ShiftEvents',
  components: {
    ShiftEventEdit
  },
  props: {
    isModal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      shift: {},
      events: null,
      isLoading: false,
      isMounted: false
    }
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('general.item.id') },
        { key: 'event.name', label: this.$t('shift.events.name') },
        { key: 'minutes', label: this.$t('shift.events.minutes') },
        { key: 'event.action', label: this.$t('shift.events.action'), format: 'formatFunc', funcs: [this.translateAction] }
      ];

      const actions = [
        { label: this.$t('general.actions.edit'), emit: 'editItem', bicon: 'pencil-fill', class: 'btn-sm btn-primary' },
        { label: this.$t('general.actions.delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-sm btn-danger' }
      ];

      headers.push({ key: 'actions', label: '', actions, classTd: 'w-10' });

      return headers;
    },
    tableActions () {
      const actions = { download: false };
      actions.add = { title: this.$t('general.actions.add') };
      return actions;
    },
    getTitle () {
      return this.$t('shift.events.title', { name: this.shift.name });
    }
  },
  methods: {
    translateAction (action) {
      return this.$t('event.action-options.' + action);
    },
    loadEvents () {
      const path = `ezuro/shifts/events/list/${this.shift.id}`;

      this.isLoading = true;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          this.events = response.data;
          this.isLoading = false;
        }
      });
    },
    editItem (el) {
      this.$refs.editElFrm.show(el, this.shift);
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(
          el,
          this.$t('general.item.deleteTitle'),
          this.$t('general.item.deleteMessage', {
            name: el.event.name,
            code: el.minutes + ' minūtes (' + this.$t('event.action-options.' + el.event.action) + ')'
          })
        )
      }
    },
    setDeleted (el, isDeleted) {
      this.isLoading = true;
      this.ApiRequest.request('ezuro/shifts/events/destroy/' + el.id, this.ApiRequest.REQUEST_GET, { }, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
          this.isLoading = false;
        } else {
          this.loadEvents();
        }
      });
    },
    show (elData) {
      this.shift = elData;
      this.loadEvents();

      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    }
  },
  mounted () {
    this.isMounted = true;
  }
}
